export default __webpack_public_path__ + "static/media/icons.ae628812.svg";